module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }